import { PhoneArrowUpRightIcon } from "@heroicons/react/24/solid";
import { Tooltip } from "antd";
import { formatTime } from "V2.0/utils";

import BulkCampaignStatus from "../BulkCampaignStatus";
import BulkCampaignActions from "./Components/BulkCampaignActions";
import BulkCampaignStat from "./Components/BulkCampaignStat";
import {
  CALL_STAT_COLUMNS,
  CALL_ROW_GRID_COLS,
} from "./Components/Columns/Call";

export default function BulkCallCampaign(props) {
  const {
    name,
    // assistant and the individually-destructured stat fields below are no longer read directly —
    // CALL_STAT_COLUMNS.getValue(props) (bulk-campaign-report-ui-port, Task 5) reads them off the
    // full `props` object instead, same as Frontend. Keeping the names commented here for reference.
    // assistant,
    // totalContacts,
    status,
    createdAt,
    // callCampaignDetails,
    onBulkCampaignClick,
    onBulkCampaignDelete,
    onBulkCampaignDownload,
    onBulkCampaignResume,
    onBulkCampaignPause,
    onBulkCampaignCancel,
    onBulkCampaignReport,
    isViewOnly,
  } = props;

  // Replaced by the shared CALL_STAT_COLUMNS (Task 3) so the row's stat columns stay in sync with
  // the table header (BulkCampaignTableHeader, Task 4) instead of being defined inline per-row.
  // const callCampaignStats = [
  //   { label: "Total Contacts", data: totalContacts },
  //   { label: "Responded Users", data: callCampaignDetails.callsCompleted },
  //   { label: "Attempted Calls", data: callCampaignDetails.callsAttempted },
  //   { label: "Failed Calls", data: callCampaignDetails.callsFailed },
  //   { label: "Not Answered", data: callCampaignDetails.callsNotAnswered },
  //   { label: "Blocked Calls", data: callCampaignDetails.callsBlocked },
  //   { label: "Voicemail / Hold", data: callCampaignDetails.voicemail },
  // ];

  return (
    // Old card-style row: fixed [auto_1fr_auto] columns inside an outlined, rounded card. Replaced
    // with Frontend's flat table-row grid (CALL_ROW_GRID_COLS, Task 3/4) so columns line up with
    // BulkCampaignTableHeader. (bulk-campaign-report-ui-port, Task 5)
    // <div
    //   className="grid grid-cols-[auto_1fr_auto] gap-x-8 hover:bg-gray-100 hover:bg-gray-100 hover:cursor-pointer hover:outline-zinc-300 outline-zinc-100 rounded-lg p-4 outline"
    //   onClick={onBulkCampaignClick}
    // >
    <div
      className={`grid ${CALL_ROW_GRID_COLS} items-center gap-x-4 hover:bg-gray-50 hover:cursor-pointer px-4 py-3`}
      onClick={onBulkCampaignClick}
    >
      <div className="flex gap-x-4 min-w-0">
        <div className="flex">
          <PhoneArrowUpRightIcon className="size-6 text-amber-500 shrink-0" />
        </div>
        {/* Old two-stacked-lines layout: plain date text + badge-variant BulkCampaignStatus in a
            fixed w-[140px] column. Replaced with Frontend's single truncating combined line below.
            (bulk-campaign-report-ui-port, Task 5) */}
        {/* <div className="flex flex-col gap-y-2 w-[140px]">
          <Tooltip title={name}>
            <p className="truncate text-sm font-semibold">{name}</p>
          </Tooltip>
          <p className="text-xs">{formatTime(createdAt)}</p>
          <div>
            <BulkCampaignStatus status={status} />
          </div>
        </div> */}
        <div className="flex flex-col gap-y-1 min-w-0">
          <Tooltip title={name}>
            <p className="truncate text-sm font-semibold">{name}</p>
          </Tooltip>
          <p className="truncate text-xs text-zinc-500">
            {formatTime(createdAt)} ·{" "}
            <BulkCampaignStatus
              status={status}
              variant="text"
            />
          </p>
        </div>
      </div>

      {/* Old stats grid: inline callCampaignStats array mapped inside its own nested
          grid-cols-3/4/7 wrapper div. Replaced with CALL_STAT_COLUMNS (Task 3) mapped directly as
          sibling grid cells of the row's own CALL_ROW_GRID_COLS. (bulk-campaign-report-ui-port, Task 5) */}
      {/* <div className="w-full gap-y-8 grid grid-cols-3 xl:grid-cols-4 2xl:grid-cols-7">
        {callCampaignStats.map((stat, idx) => {
          return (
            <BulkCampaignStat
              key={idx}
              label={stat.label}
              data={stat.data}
            />
          );
        })}
      </div> */}
      {CALL_STAT_COLUMNS.map((col) => (
        <BulkCampaignStat
          key={col.headerLabel}
          label={col.rowLabel}
          data={col.getValue(props)}
        />
      ))}

      {/* Old wrapping div (flex items-center) around BulkCampaignActions is no longer needed —
          BulkCampaignActions is now a direct grid cell sized by CALL_ROW_GRID_COLS's trailing
          actions column. (bulk-campaign-report-ui-port, Task 5) */}
      {/* <div className="flex items-center"> */}
      <BulkCampaignActions
        isViewOnly={isViewOnly}
        bulkCampaignStatus={status}
        onBulkCampaignDownload={onBulkCampaignDownload}
        onBulkCampaignDelete={onBulkCampaignDelete}
        onBulkCampaignResume={onBulkCampaignResume}
        onBulkCampaignPause={onBulkCampaignPause}
        onBulkCampaignCancel={onBulkCampaignCancel}
        onBulkCampaignReport={onBulkCampaignReport}
      />
      {/* </div> */}
    </div>
  );
}
